import { configureStore } from "@reduxjs/toolkit";
import { conversionApi } from "./api/conversionApi";

export const store = configureStore({
  reducer: {
    [conversionApi.reducerPath]: conversionApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(conversionApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
